export default "__VITE_ASSET__DqQ77mA5__"